import { WindowMU } from "app/types/WindowMU";
import { ControllerBase } from "controllerBase";

declare var window: WindowMU

const PesquisarClassesProdutosController = ControllerBase.extend({
    name: "PesquisarClassesProdutosController",

    ajax: function() {

        return {
            url: "/Produto/_ClassesProdutos",
            type: "get",
            cache: false
        };
    },

    renderizado: function() {

        var ul = $("#arvore-classes");
        ul.empty();

        $("#mostrar-historico-filtro").hide();
        $("#menu-consulta-produtos").hide();
        $("#menu-sub-consulta-produtos").hide();

        this.renderizarNiveis(ul, null, 1, null);
    },

    renderizarNiveis: function(ul, elPai, nivel, itemPai) {

        var classes = global.where(this.model, { Nivel: nivel });

        if (!classes || classes.length == 0) {
            return false;
        }

        var self = this;

        if (!ul) {
            ul = $("<ul>");
        }

        var possui = false;

        $.each(classes,
            function() {

                if (!itemPai || this.Hierarquia.indexOf(itemPai.Hierarquia) == 0) {

                    possui = true;

                    var li = $("<li>", { nivel: nivel });
                    ul.append(li);

                    var a = $("<a>", { href: "#", 'class': "contrai" });
                    a.click($.proxy(self.expandirContrair, self));
                    li.append(a);

                    var a2 = $("<a>", { href: "#" });
                    a2.html(this.Nome);
                    a2.click($.proxy(self.selecionar, self, this));
                    li.append(a2);

                    var div = $("<div>", { nivel: nivel });
                    li.append(div);
                    div.hide();


                    var possuiSubNiveis = self.renderizarNiveis(null, div, this.Nivel + 1, this);

                    if (!possuiSubNiveis) {
                        a.addClass("limpo");
                    }
                }

            });


        if (possui && elPai) {
            elPai.append(ul);
        }

        return possui;

    },

    expandirContrair: function(e) {

        e.preventDefault();

        var li = $(e.target).parent();
        var nivel = li.attr("nivel");

        if (li.hasClass("expandido")) {
            li.removeClass("expandido");

            $("div[nivel=" + nivel + "]", li).slideUp();
        } else {
            li.addClass("expandido");
            $("div[nivel=" + nivel + "]", li).slideDown();
        }

    },

    selecionar: function(classe, e) {

        if (this.classeSelecionadaCallback) {
            this.classeSelecionadaCallback(classe);
        }

    }

})

window.PesquisarClassesProdutosController = PesquisarClassesProdutosController

export {
    PesquisarClassesProdutosController
}